import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const createLead = (data) => axios.post(`${API}/leads`, data);
export const createBooking = (data) => axios.post(`${API}/bookings`, data);
export const getBookedSlots = (date) => axios.get(`${API}/bookings/slots`, { params: { date } });
export const getLeads = (key) => axios.get(`${API}/leads`, { headers: { "X-Admin-Key": key } });
export const getBookings = (key) => axios.get(`${API}/bookings`, { headers: { "X-Admin-Key": key } });
